import React from "react";
import { Box } from "@mui/material";

// Template182: Consejos 2 SF - bloques desde page (header, tips: icon + text; text puede ser HTML)
const Template182 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const contentColor = textColor || "#444";
	const headerText =
		page.texts?.[0]?.content ?? "Consejos útiles para San Francisco";
	const tips = Array.isArray(page.tips)
		? page.tips
		: Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
				? page.data.data.tips
				: [];

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100vh",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: headerBackgroundColor || "#F2B705",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
			</Box>
			<Box
				data-block-id="text-1"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					marginTop: 2.5,
				}}
			>
				{tips.map((tip, index) => (
					<Box
						key={index}
						data-block-id={`text-${index + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #fbf0cf",
						}}
					>
						<Box sx={{ fontSize: 18 }}>{tip.icon ?? ""}</Box>
						<Box sx={{ fontSize: 13, color: contentColor }}>
							{tip.html && typeof tip.text === "string" ? (
								<span dangerouslySetInnerHTML={{ __html: tip.text }} />
							) : (
								(typeof tip.text === "string" ? tip.text : "") || ""
							)}
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template182.thumbnail = "/images/template-1.png";
export default Template182;
